import { Location } from '../models/location.model';
import { ListItem } from '../models/ListItem';
import GenericService from './genericService';
import { httpService } from './httpService';


class LocationService extends GenericService<Location, ListItem> {
  constructor() {
    super('/api/Locations');
  }
  async getByCityId(id: number | string): Promise<Location[]> {
          return await httpService.get<Location[]>(`/api/Locations/GetByCityId/${id}`, undefined, {
              unwrap: true,
              normalize: true,
              toast: false,
          });
      }
}

export const locationService = new LocationService();